module.exports = require("@wildboar/x500/src/lib/modules/BasicAccessControl/rule-and-basic-access-control.va");